module.exports = __webpack_public_path__ + "static/media/background-silder.192e8b74.webp";